import React, { useState, useEffect } from "react";
import { Collapse } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./css/styles.css";

const Header = ({ menudata }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const url = location.pathname;

  const [activeMenu, setActiveMenu] = useState(null);
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  const closeOffcanvas = () => {
    const offcanvasEl = document.getElementById("offcanvasScrolling");
    if (offcanvasEl) {
      if (window.bootstrap?.Offcanvas) {
        const bsOffcanvas = window.bootstrap.Offcanvas.getInstance(offcanvasEl);
        if (bsOffcanvas) {
          bsOffcanvas.hide();
        }
      }
      const closeBtn = offcanvasEl.querySelector(".btn-close");
      if (closeBtn) {
        closeBtn.click();
      }
    }
  };

  useEffect(() => {
    closeOffcanvas();
  }, [location.pathname]);

  const handleMenuClick = (index) => {
    setActiveMenu(activeMenu === index ? null : index);
  };

  const handleSubMenuClick = (key) => {
    setActiveSubMenu(activeSubMenu === key ? null : key);
  };

  const handleNavClick = (e, targetUrl) => {
    e.preventDefault();
    closeOffcanvas();
    if (!targetUrl || targetUrl === "#") {
      return;
    }
    if (targetUrl.startsWith("http://") || targetUrl.startsWith("https://")) {
      window.location.href = targetUrl;
    } else {
      navigate(targetUrl);
    }
  };

  const isPublished = (item) =>
    item && item.status !== 0 && item.status !== "0";

  const getVisibleChildren = (children) =>
    children ? children.filter(isPublished) : [];

  return (
    <>
      {/* Desktop View */}
      <header className="site-header">
        <div className="top-header-bar">
          <div className="container">
            <div className="row flex-wrap justify-content-center justify-content-lg-between align-items-lg-center">
              <div className="col-12 col-lg-8 d-none d-md-flex flex-wrap justify-content-center justify-content-lg-start mb-3 mb-lg-0">
                <div className="header-bar-email" style={{ fontSize: "13px" }}>
                  <i
                    className="fa fa-envelope"
                    style={{ color: "#f6c93f" }}
                  ></i>
                  <a href="mailto:bpjohannesocd@gmail.com">
                    <span
                      className="__cf_email__"
                      style={{ marginLeft: "0.5rem" }}
                    >
                      bpjohannesocd@gmail.com
                    </span>
                  </a>
                </div>
                <div
                  className="header-bar-text align-items-center justify-content-center"
                  style={{ fontSize: "13px" }}
                >
                  <i className="fa fa-phone" style={{ color: "#f6c93f" }}></i>
                  <a href="tel:+918790831322" style={{ marginLeft: "0.3rem" }}>
                    8790831322
                  </a>
                </div>
              </div>
              <div className="col-12 col-lg-4 d-flex flex-wrap justify-content-center justify-content-lg-end align-items-center">
                <div className="social-icons">
                  <div className="social-icon">
                    <a href="https://www.facebook.com/profile.php?id=61563594005968&mibextid=ZbWKwL" target="_blank" rel="noreferrer">
                      <i className="fab fa-facebook" />
                    </a>
                  </div>
                  <div className="social-icon">
                    <a href="https://www.youtube.com/@Kurnooldiocese" target="_blank" rel="noreferrer">
                      <i className="fab fa-youtube" />
                    </a>
                  </div>
                  <div className="social-icon">
                    <a href="/" target="_blank" rel="noreferrer">
                      <i className="fab fa-instagram" />
                    </a>
                  </div>
                </div>
                <button
                  className="btn btn-success btn-sm donate-btn ml-3"
                  id="btnmore"
                  onClick={() => window.location.href = "https://kurnooldiocese.org/donation"}
                >
                  <i className="fas fa-donate"></i> Donation
                </button>
              </div>
            </div>
          </div>
        </div>
        <section id="sp-section-3">
          <div className="container-fluid p-0">
            <picture>
              <source media="(max-width: 991px)" srcSet="images/all-img/mainmobile.jpg" />
              <source media="(min-width: 992px)" srcSet="images/all-img/updatebanner.jpg" />
              <img
                src="images/all-img/mainmobile.jpg"
                alt="Diocese of Kurnool Banner"
                className="w-100"
                style={{ display: "block", maxHeight: "250px", objectFit: "cover" }}
              />
            </picture>
          </div>
        </section>
        <div className="main-navigation-container d-none d-lg-block">
          <nav
            className="navbar navbar-expand-lg navbar-light custom-menu"
            style={{ height: "51px", zIndex: "9" }}
          >
            <button
              className="navbar-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse header-align-center"
              id="navbarNav"
            >
              <ul className="main-navigation">
                {menudata?.map((menuItem, index) => {
                  const visibleChildren = getVisibleChildren(menuItem.children);
                  const hasChildren = visibleChildren.length > 0;
                  return (
                    <li
                      key={index}
                      className={
                        hasChildren ? "menu-item-has-children" : "menu-item"
                      }
                    >
                      {hasChildren ? (
                        <Link
                          to={menuItem.url}
                          className={`${
                            visibleChildren.some((child) =>
                              url.includes(child.url)
                            )
                              ? "activemain"
                              : ""
                          }`}
                        >
                          <span>{menuItem.label}</span>
                          <i
                            className="fa fa-chevron-down nav-arrow"
                            aria-hidden="true"
                          />
                        </Link>
                      ) : (
                        <Link
                          to={menuItem.url}
                          className={`${
                            url === menuItem.url ? "activemain" : ""
                          }`}
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {menuItem.label}
                        </Link>
                      )}
                      {hasChildren && (
                        <ul className="sub-menu">
                          {visibleChildren.map((subItem, subIndex) => {
                            const visibleSubChildren = getVisibleChildren(
                              subItem.subchildren
                            );
                            const hasSubChildren = visibleSubChildren.length > 0;
                            return (
                              <li
                                key={subIndex}
                                className={
                                  hasSubChildren
                                    ? "menu-item-has-children"
                                    : "menu-item"
                                }
                              >
                                {hasSubChildren ? (
                                  <Link to={subItem.url}>
                                    <span>{subItem.label}</span>
                                    <i
                                      className="fa fa-chevron-right subnav-arrow"
                                      aria-hidden="true"
                                    />
                                  </Link>
                                ) : (
                                  <Link to={subItem.url}>{subItem.label}</Link>
                                )}
                                {hasSubChildren && (
                                  <ul className="sub-menu">
                                    {visibleSubChildren.map(
                                      (childSubItem, childSubIndex) => (
                                        <li
                                          key={childSubIndex}
                                          className="menu-item"
                                        >
                                          <Link to={childSubItem.url}>
                                            {childSubItem.label}
                                          </Link>
                                        </li>
                                      )
                                    )}
                                  </ul>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </nav>
        </div>
      </header>

      {/* Mobile View */}
      <div
        className="d-block d-lg-none "
        style={{ backgroundColor: "rgb(13 69 113)" }}
      >
        <button
          className="btn btn-success"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasScrolling"
          aria-controls="offcanvasScrolling"
          style={{ background: "#f6c93f", fontSize: "11px" }}
        >
          <i className="fa fa-bars"></i>
        </button>
        <div
          className="offcanvas offcanvas-start"
          data-bs-scroll="true"
          data-bs-backdrop="true"
          tabIndex={-1}
          id="offcanvasScrolling"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div className="offcanvas-header border-bottom">
            <h5 className="text-center mb-0 fw-bold" style={{ color: "#0d4571" }}>Diocese of Kurnool</h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body" style={{ overflowY: "auto" }}>
            <div className="nav-bar">
              <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                {menudata?.map((menuItem, index) => {
                  const visibleChildren = getVisibleChildren(menuItem.children);
                  const hasChildren = visibleChildren.length > 0;
                  return (
                    <li
                      key={index}
                      className={
                        hasChildren ? "menu-item-has-children" : "menu-item"
                      }
                      style={{ display: "block", borderBottom: "1px solid #edf2f7" }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        {hasChildren ? (
                          <div
                            onClick={() => handleMenuClick(index)}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              width: "100%",
                              padding: "13px 16px",
                              cursor: "pointer",
                              color: "#0f172a",
                              fontWeight: "600",
                              fontSize: "15px",
                              backgroundColor: activeMenu === index ? "#f1f5f9" : "transparent",
                              transition: "background-color 0.15s ease",
                            }}
                          >
                            <span>{menuItem.label}</span>
                            <i
                              className={`fa fa-chevron-${activeMenu === index ? "up" : "down"}`}
                              style={{
                                fontSize: "11px",
                                color: "#475569",
                                padding: "4px 7px",
                                backgroundColor: activeMenu === index ? "#e2e8f0" : "transparent",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        ) : (
                          <a
                            href={menuItem.url}
                            onClick={(e) => handleNavClick(e, menuItem.url)}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                              padding: "13px 16px",
                              textDecoration: "none",
                              color: "#0f172a",
                              fontWeight: "600",
                              fontSize: "15px",
                              cursor: "pointer",
                            }}
                          >
                            <span>{menuItem.label}</span>
                            <i
                              className="fa fa-angle-right"
                              style={{ fontSize: "13px", color: "#cbd5e1" }}
                            />
                          </a>
                        )}
                      </div>
                      {hasChildren && (
                        <Collapse in={activeMenu === index}>
                          <div
                            style={{
                              backgroundColor: "#f8fafc",
                              border: "1px solid #e2e8f0",
                              borderRadius: "8px",
                              margin: "6px 8px 10px 8px",
                              overflow: "hidden",
                            }}
                          >
                            <ul
                              className="sub-menu-mobile"
                              style={{
                                listStyleType: "none",
                                padding: 0,
                                margin: 0,
                              }}
                            >
                              {visibleChildren.map((subItem, subIndex) => {
                                const visibleSubChildren = getVisibleChildren(
                                  subItem.subchildren
                                );
                                const hasSubChildren =
                                  visibleSubChildren.length > 0;
                                const subKey = `${index}-${subIndex}`;
                                const isSubLast =
                                  subIndex === visibleChildren.length - 1 &&
                                  !hasSubChildren;
                                return (
                                  <li
                                    key={subIndex}
                                    className={
                                      hasSubChildren
                                        ? "menu-item-has-children"
                                        : "menu-item"
                                    }
                                    style={{
                                      display: "block",
                                      borderBottom: isSubLast
                                        ? "none"
                                        : "1px solid #e5ecf3",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      {hasSubChildren ? (
                                        <div
                                          onClick={() =>
                                            handleSubMenuClick(subKey)
                                          }
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: "100%",
                                            padding: "12px 14px",
                                            cursor: "pointer",
                                            color: "#0f172a",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            backgroundColor:
                                              activeSubMenu === subKey
                                                ? "#eef2f6"
                                                : "transparent",
                                            transition:
                                              "background-color 0.15s ease",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "8px",
                                            }}
                                          >
                                            <i
                                              className="fa fa-folder-open"
                                              style={{
                                                fontSize: "12px",
                                                color: "#0d4571",
                                              }}
                                            />
                                            <span>{subItem.label}</span>
                                          </span>
                                          <i
                                            className={`fa fa-chevron-${
                                              activeSubMenu === subKey
                                                ? "up"
                                                : "down"
                                            }`}
                                            style={{
                                              fontSize: "10px",
                                              color: "#64748b",
                                              padding: "4px 6px",
                                              backgroundColor:
                                                "rgba(0,0,0,0.04)",
                                              borderRadius: "4px",
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <a
                                          href={subItem.url}
                                          onClick={(e) =>
                                            handleNavClick(e, subItem.url)
                                          }
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            width: "100%",
                                            padding: "12px 14px",
                                            textDecoration: "none",
                                            color: "#334155",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                            cursor: "pointer",
                                          }}
                                        >
                                          <span>{subItem.label}</span>
                                          <i
                                            className="fa fa-angle-right"
                                            style={{
                                              fontSize: "12px",
                                              color: "#94a3b8",
                                            }}
                                          />
                                        </a>
                                      )}
                                    </div>
                                    {hasSubChildren && (
                                      <Collapse
                                        in={activeSubMenu === subKey}
                                      >
                                        <div
                                          className="child-sub-menu-container"
                                          style={{
                                            backgroundColor: "#ffffff",
                                            borderRadius: "8px",
                                            border: "1px solid #e2e8f0",
                                            borderLeft: "3.5px solid #0d4571",
                                            boxShadow:
                                              "0 2px 8px rgba(13, 69, 113, 0.08)",
                                            margin: "6px 8px 10px 10px",
                                            overflow: "hidden",
                                          }}
                                        >
                                          <ul
                                            className="child-sub-menu-mobile"
                                            style={{
                                              listStyleType: "none",
                                              padding: 0,
                                              margin: 0,
                                            }}
                                          >
                                            {visibleSubChildren.map(
                                              (childSubItem, childSubIndex) => {
                                                const isLast =
                                                  childSubIndex ===
                                                  visibleSubChildren.length - 1;
                                                return (
                                                  <li
                                                    key={childSubIndex}
                                                    className="child-menu-item"
                                                    style={{
                                                      display: "block",
                                                      borderBottom: isLast
                                                        ? "none"
                                                        : "1px solid #f1f5f9",
                                                    }}
                                                  >
                                                    <a
                                                      href={childSubItem.url}
                                                      onClick={(e) =>
                                                        handleNavClick(
                                                          e,
                                                          childSubItem.url
                                                        )
                                                      }
                                                      style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent:
                                                          "space-between",
                                                        padding: "11px 14px",
                                                        textDecoration: "none",
                                                        color: "#334155",
                                                        fontSize: "13.5px",
                                                        fontWeight: "500",
                                                        cursor: "pointer",
                                                        backgroundColor:
                                                          "#ffffff",
                                                        transition:
                                                          "background-color 0.15s ease",
                                                      }}
                                                      onMouseEnter={(e) =>
                                                        (e.currentTarget.style.backgroundColor =
                                                          "#f8fafc")
                                                      }
                                                      onMouseLeave={(e) =>
                                                        (e.currentTarget.style.backgroundColor =
                                                          "#ffffff")
                                                      }
                                                    >
                                                      <span
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: "10px",
                                                        }}
                                                      >
                                                        <i
                                                          className="fa fa-angle-right"
                                                          style={{
                                                            fontSize: "11px",
                                                            color: "#0d4571",
                                                            opacity: 0.8,
                                                          }}
                                                        />
                                                        <span>
                                                          {childSubItem.label}
                                                        </span>
                                                      </span>
                                                      <i
                                                        className="fa fa-chevron-right"
                                                        style={{
                                                          fontSize: "9px",
                                                          color: "#cbd5e1",
                                                        }}
                                                      />
                                                    </a>
                                                  </li>
                                                );
                                              }
                                            )}
                                          </ul>
                                        </div>
                                      </Collapse>
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        </Collapse>
                      )}
                    </li>
                  );
                })}
              </ul>
              <div
                className="copyright"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  marginTop: "1rem",
                  marginBottom: "1rem",
                }}
              >
                <p
                  className="text-center"
                  style={{ fontSize: "13px", color: "#999" }}
                >
                  {" "}
                  &copy; {new Date().getFullYear()} Diocese of Kurnool
                </p>
                <p
                  className="text-center"
                  style={{ fontSize: "13px", color: "#999" }}
                >
                  Powered by{" "}
                  <a
                    href="https://boscosofttech.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#666" }}
                  >
                    BoscoSoft Technologies
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
